import mock from '../MockConfig';
import analytics from '../../db/dashboard/analytics';
import ecommerce from '../../db/dashboard/ecommerce';
import crm from '../../db/dashboard/crm';
import crypto from '../../db/dashboard/crypto';
import metrics from '../../db/dashboard/metrics';
import widgets from '../../db/dashboard/widgets';
import healthCare from '../../db/dashboard/healthCare';
import academy from '../../db/dashboard/academy';
import { API } from 'shared/constants/AppEnums';

// Define all mocks of dashboard
mock.onGet('/dashboard/analytics').reply(200, analytics);

mock.onGet('/dashboard/ecommerce').reply(200, ecommerce);

mock.onGet('/dashboard/crm').reply(200, crm);

mock.onGet('/dashboard/crypto').reply(200, crypto);

mock.onGet('/dashboard/health_care').reply(200, healthCare);

mock.onGet('/dashboard/academy').reply(200, academy);

mock.onGet('/dashboard/metrics').reply(200, metrics);

mock.onGet('/dashboard/widgets').reply(200, widgets);

export const getInfografis = async (page, tab, limit) => {
    try {
        let url = ''
        if (page === 1) {
            url = API.INFOGRAFIS.replace('$value', tab).replace('&page=$page', '').replace('$limit', limit)
        } else {
            url = API.INFOGRAFIS.replace('$value', tab).replace('$page', page).replace('$limit', limit)
        }
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
            }
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const getTeknologiTerbaru = async (page, limit) => {
    try {
        let url = ''
        if (page === 1) {
            url = API.TEKNOLOGI_TERBARU.replace('page=$page&', '').replace('$limit', limit)
        } else {
            url = API.TEKNOLOGI_TERBARU.replace('$page', page).replace('$limit', limit)
        }
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
            }
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const getEmployee = async (page, limit, tahun, triwulan, unker, status, search) => {
    try {
        let url = ''
        if (page === 1) {
            url = API.GET_EMPLOYEE.replace('page=$page&', '').replace('$limit', limit).replace('$year', tahun).replace('$quarter', triwulan).replace('$unker', unker).replace('$status', status).replace('$general', search)
        } else {
            url = API.GET_EMPLOYEE.replace('$page', page).replace('$limit', limit).replace('$year', tahun).replace('$quarter', triwulan).replace('$unker', unker).replace('$status', status).replace('$general', search)
        }
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
            }
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const getEmployeeV2 = async (page, limit, tahun, triwulan, unker, status, search) => {
    try {
        let url = ''
        if (page === 1) {
            url = API.GET_EMPLOYEE_V2.replace('page=$page&', '').replace('$limit', limit).replace('$year', tahun).replace('$quarter', triwulan).replace('$unker', unker).replace('$status', status).replace('$general', search)
        } else {
            url = API.GET_EMPLOYEE_V2.replace('$page', page).replace('$limit', limit).replace('$year', tahun).replace('$quarter', triwulan).replace('$unker', unker).replace('$status', status).replace('$general', search)
        }
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
            }
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const getDownloadMonitoring = async (tahun, triwulan, unker, status, search) => {
    try {
        const response = await fetch(API.GET_DOWNLOAD_MONITORING.replace('$year', tahun).replace('$quarter', triwulan).replace('$unker', unker).replace('$status', status).replace('$general', search), {
            method: 'GET',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
            }
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const getDownloadMonitoringV2 = async (tahun, triwulan, unker, status, search) => {
    try {
        const response = await fetch(API.GET_DOWNLOAD_MONITORING_V2.replace('$year', tahun).replace('$quarter', triwulan).replace('$unker', unker).replace('$status', status).replace('$general', search), {
            method: 'GET',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
            }
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const getUnitKerja = async () => {
    try {
        const response = await fetch(API.GET_UNIT_KERJA, {
            method: 'GET',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
            }
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const getDetailEmployee = async (id) => {
    try {
        const response = await fetch(API.GET_DETAIL_EMPLOYEE.replace('$id', id), {
            method: 'GET',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
            }
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const getDownloadMobileApp = async (type) => {
    try {
        const response = await fetch(API.GET_MOBILE_APP.replace('$appType', type), {
            method: 'GET',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
            }
        })
        return response.json()
    } catch (error) {
        return error
    }
}